import * as React from 'react';
import { createElement } from 'react';
import { Card, Button, Icon, Divider } from '@alifd/next';
import { parseRequsetParams, parseResponseParams } from '@/utils';
import requestApi from '@/utils/request';
import './index.scss';
const { Header, Content } = Card;
const ProCard = (props) => {
    const [collapse, setCollapse] = React.useState(false);
    const { children, title, color = '#5584FF', isCollapse = true, isShowHeader = true, operations = [], field } = props;
    const extra = () => {
        const handleClick = async (onClick, service) => {
            const { api, request: { map: requestMap = {} } = {}, response: { map: responseMap = {} } = {}, } = service;
            const { rqstModeCd = 'post', intfPath } = api;
            const requestParams = parseRequsetParams(requestMap, field);
            const methodStr = rqstModeCd.toLowerCase();
            const method = methodStr ?? 'post';
            const { content: data } = await requestApi[method](intfPath, requestParams);
            const responseData = parseResponseParams(responseMap, data);
            field.setValues(responseData);
            return new Promise((resolve) => {
                onClick();
                resolve(true);
            });
        };
        return (isCollapse && (createElement("div", { style: { display: 'flex', alignItems: 'center' } },
            operations.map(({ id, content, type, onClick, beforeAction, afterAction, service }) => {
                const hanldeClick = async () => {
                    beforeAction && (await beforeAction());
                    onClick && (await handleClick(onClick, service));
                    afterAction && (await afterAction());
                };
                return (createElement(Button, { text: true, type: type, key: id, onClick: hanldeClick, style: { marginRight: 8 } }, content));
            }),
            operations.length > 0 && createElement(Divider, { direction: "ver" }),
            createElement(Button, { text: true, type: "primary", onClick: () => setCollapse(!collapse) },
                collapse ? '展开' : '收起',
                createElement(Icon, { type: collapse ? 'arrow-down' : 'arrow-up' })))));
    };
    const renderTitle = () => {
        return (createElement("div", { className: "title-container", style: { color } },
            createElement("div", { className: "divider", style: { backgroundColor: color } }),
            createElement("div", null, title)));
    };
    return (createElement(Card, { free: true, hasBorder: false },
        isShowHeader && createElement(Header, { title: renderTitle(), extra: extra() }),
        createElement(Content, { style: {
                display: collapse ? 'none' : 'block',
                marginTop: isShowHeader ? 12 : 0,
                paddingBottom: 0,
            } }, children)));
};
export default ProCard;
